import React, { useState, useEffect } from "react";
import { MdBoy, MdGirl } from "react-icons/md";
import { Link } from "react-router-dom";
import "react-calendar/dist/Calendar.css";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaBell,
  FaIdCard,
  FaMoneyBillWave,
} from "react-icons/fa";

import {
  MdAssignment,
  MdHolidayVillage,
  MdOutlineLibraryBooks,
} from "react-icons/md";

import {
  HiOutlineClipboardDocumentCheck,
} from "react-icons/hi2";

import {
  PiStudentBold,
  PiExamBold,
} from "react-icons/pi";

import { LiaChalkboardTeacherSolid } from "react-icons/lia";
import { getDashCount } from "../../store/slices/auth";

const quickCards = [
  {
    title: "Staff",
    icon: <FaChalkboardTeacher />,
    link: "/institute/staffs",
    color: "#10b981",
  },
  {
    title: "Student",
    icon: <FaUserGraduate />,
    link: "/institute/students",
    color: "#f59e0b",
  },
  {
    title: "Homework",
    icon: <MdAssignment />,
    link: "/institute/homework",
    color: "#6366f1",
  },
  {
    title: "Report Card",
    icon: <PiExamBold />,
    link: "/institute/result",
    color: "#ec4899",
  },
  {
    title: "Fees",
    icon: <FaMoneyBillWave />,
    link: "/institute/fees",
    color: "#0ea5e9",
  },
  {
    title: "Set Marks",
    icon: <HiOutlineClipboardDocumentCheck />,
    link: "/institute/set-marks",
    color: "#8b5cf6",
  },
  {
    title: "Notice Board",
    icon: <FaBell />,
    link: "/institute/notices",
    color: "#ef4444",
  },
  {
    title: "Class Teacher",
    icon: <LiaChalkboardTeacherSolid />,
    link: "/institute/classteachers",
    color: "#14b8a6",
  },
  {
    title: "Holiday",
    icon: <MdHolidayVillage />,
    link: "/institute/holidays",
    color: "#f97316",
  },
  {
    title: "Subject Teacher",
    icon: <MdOutlineLibraryBooks />,
    link: "/institute/subjectteachers",
    color: "#22c55e",
  },
  {
    title: "Staff ID",
    icon: <FaIdCard />,
    link: "/institute/staff-id",
    color: "#3b82f6",
  },
  {
    title: "Student ID",
    icon: <PiStudentBold />,
    link: "/institute/student-id",
    color: "#7c3aed",
  },
];
export default function DashboardHome() {
  const dispatch = useDispatch();

  const { dashCount, loading } = useSelector((state) => state.auth);

  useEffect(() => {

    dispatch(getDashCount());

    return () => {
      console.log("DashboardHome Unmounted");
    };
  }, []);

  return (
    <>
      <div className="homepage-container">
        <Container fluid className="dh-container">
          <div className="countdetails-wrapper">
            <div className="countdetails-card">
              <div className="countdetails-icon">
                <FaUserGraduate />
              </div>
              <div className="countdetails-text">
                <p>Total Students</p>
                <h3>{loading ? "..." : dashCount?.totalStudents ?? 0}</h3>
              </div>
            </div>

            <div className="countdetails-card">
              <div className="countdetails-icon">
                <FaChalkboardTeacher />
              </div>
              <div className="countdetails-text">
                <p>Total Staff</p>
                <h3>{loading ? "..." : dashCount?.totalStaff ?? 0}</h3>
              </div>
            </div>

            <div className="countdetails-card">
              <div className="countdetails-icon">
                <MdBoy size={30} />
              </div>
              <div className="countdetails-text">
                <p>Total Boys</p>
                <h3>{loading ? "..." : dashCount?.totalBoys ?? 0}</h3>
              </div>
            </div>

            <div className="countdetails-card">
              <div className="countdetails-icon">
                <MdGirl size={30} />
              </div>
              <div className="countdetails-text">
                <p>Total Girls</p>
                <h3>{loading ? "..." : dashCount?.totalGirls ?? 0}</h3>
              </div>
            </div>
          </div>

          <h5 className="quick-access-title mt-5">Quick Access</h5>

          <div className="row g-4">
            {quickCards.map((item, index) => (
              <div
                className="col-6 col-md-4 col-lg-3 col-xl-2"
                key={index}
              >
                <Link to={item.link} className="quick-card-link">
                  <div
                    className="quick-card"
                    style={{ "--card-color": item.color }}
                  >
                    <div
                      className="quick-card-icon"
                      style={{
                        background: `${item.color}15`,
                        color: item.color,
                      }}
                    >
                      {item.icon}
                    </div>

                    <h5>{item.title}</h5>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </Container>
      </div>
    </>
  );
}
